import type { ReactionModel, ReactionResponse } from './Reactions.types';

import type { AddReactionMutation } from './AddReactionMutation.generated';
import { convertSkinToEmojiMartFormat } from './convertSkinToEmojiMartFormat';

type AddReactionResponse = AddReactionMutation['addReaction'];

export const convertReactionToClientFormat = ({
  id,
  idEmoji,
  idMember,
  idModel,
  member,
  emoji,
}: AddReactionResponse | ReactionResponse): ReactionModel => ({
  id,
  idEmoji: idEmoji.toUpperCase(),
  idMember,
  idModel,
  emoji: {
    id: emoji.shortName.toUpperCase(),
    name: emoji.name ?? '',
    colons: `:${emoji.shortName}${
      emoji.skinVariation
        ? `::skin-tone-${convertSkinToEmojiMartFormat(emoji.skinVariation)}`
        : ''
    }:`,
    emoticons: [],
    unified: emoji.unified,
    skin: emoji.skinVariation
      ? convertSkinToEmojiMartFormat(emoji.skinVariation)
      : null,
    native: emoji.native,
  },
  member: {
    id: member.id,
    fullName: member.fullName ?? undefined,
  },
});
